import { Directive, forwardRef, Attribute } from "@angular/core";
import { Validator, AbstractControl, NG_VALIDATORS } from "@angular/forms";

@Directive({
  selector:
    "[password][formControlName],[password][formControl],[password][ngModel]",
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => PasswordValidator),
      multi: true,
    },
  ],
})
export class PasswordValidator implements Validator {
  constructor(@Attribute("password") public password: string) {}

  validate(c: AbstractControl): { [key: string]: any } {
    // self value
    let v = c.value;

    // value not equal
    if (v && !this.isValidPassword(v)) {
      return {
        password: false,
      };
    }

    return null;
  }

  isValidPassword(password: string) {
    //(?=.*\d)(?=.*[a-z])(?=.*[A-Z])
    var re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}/;
    return re.test(password);
  }
}



// WEBPACK FOOTER //
// ./src/app/_directives/password.validator.ts